// flash 開出去的 swal／alert 是否還留在畫面上。bfcache 還原時靠它判斷該不該清掉，
// 才不會誤關站台自己為了別的用途（例如確認對話框）開的 swal。
let flashVisible = false

export function flash_msg(msg, type, opts) {
  type = type || 'warning'
  opts = opts || {}
  if (!opts.disable_swal && typeof window.Swal !== 'undefined') {
    flashVisible = true
    window.Swal.fire({ title: null, text: msg, icon: type })
  } else {
    if (type === 'error') {
      type = 'danger'
    }
    const container = document.querySelector('.js-flash-message')
    if (container) {
      const div = document.createElement('div')
      div.className =
        'alert alert-dismissible fade show mt-3 js-flash-alert alert-' + type
      div.setAttribute('role', 'alert')
      div.innerHTML =
        msg +
        '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>'
      container.appendChild(div)
      flashVisible = true
    }
  }
}

// 清掉目前畫面上的 flash。供 bfcache 還原時使用（見 flash-message.js 的 pageshow）：
// 還原的是離開前那一刻的 DOM 快照，訊息本身早就在前一次載入被 /api/flash.json 消費掉了。
export function clear_flash_msg() {
  if (!flashVisible) return
  flashVisible = false
  if (
    typeof window.Swal !== 'undefined' &&
    typeof window.Swal.isVisible === 'function' &&
    window.Swal.isVisible()
  ) {
    window.Swal.close()
  }
  document
    .querySelectorAll('.js-flash-message .js-flash-alert')
    .forEach((el) => el.remove())
}
